import React from 'react';
import  GitaDharaClass2  from 'views/GitaDharaClass2';

const AccountGeneralPage = () => {
  return <GitaDharaClass2/>;
};

export default AccountGeneralPage;